import { createFileRoute } from "@tanstack/react-router";
import TossochtendOrganiseren from "@/pages/TossochtendOrganiseren";

export const Route = createFileRoute("/tossochtend-organiseren")({
  head: () => ({
    meta: [
      { title: "Tossochtend organiseren bij je tennisclub | De Hussel App" },
      { name: "description", content: "Een tossochtend opzetten zonder tossleider? Automatische loting, push-meldingen en eerlijke indelingen — alles via de telefoon van je leden." },
      { property: "og:title", content: "Tossochtend organiseren bij je tennisclub | De Hussel App" },
      { property: "og:description", content: "Een tossochtend opzetten zonder tossleider? Automatische loting, push-meldingen en eerlijke indelingen — alles via de telefoon van je leden." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/tossochtend-organiseren" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/tossochtend-organiseren" }],
  }),
  component: TossochtendOrganiseren,
});
